module.exports = __webpack_public_path__ + "static/media/paragraphe4.bc9a8ee3.jpg";